import type { FC } from "react";

const U2000UnAuthorized: FC = () => {
  return <h1>UnAuthorized</h1>;
};

export default U2000UnAuthorized;
